import { differenceInMonths, eachYearOfInterval, endOfQuarter, endOfYear, format, Locale, startOfQuarter, startOfYear } from "date-fns"
import { ContractPrice, GroupingSimulation } from "./ContractPrice"
import { IElectricityOmipPricesPTHistory } from "./OmipPrice"
import * as _ from "lodash"
import { pt } from "date-fns/locale"
import { IPriceLine, IPriceVersion, IProductParticularCondition } from "./EconomicConditions"
import { IPrice } from "./Price"

export namespace PricePeriods {
    export class ElectricityPrices {
        deliveryEndDate: Date
        deliveryStartDate: Date
        priceReference: string
        description: string
        id: string
        peak: number
        standard: number
        offPeak: number
        superOffPeak: number

        spGeneralConditionId?: number
        spParticularConditionId?: number
        spElectricityEconomicConditionId?: number
        supplierProductId?: number

        spParticularCondition?: IProductParticularCondition
        
        priceLines: IPriceLine[] = []
        priceVersions: IPriceVersion[] = []

        basePrice: number = 0
        coverPercentage: number = 0

        omipElectricityHistory?: IElectricityOmipPricesPTHistory

        constructor(
            deliveryEndDate: Date | string,
            deliveryStartDate: Date | string,
            priceReference: string,
            description: string,
            id: string,
            peak: number = 0,
            standard: number = 0,
            offPeak: number = 0,
            superOffPeak: number = 0,
            spGeneralConditionId?: number,
            spParticularConditionId?: number,
            spElectricityEconomicConditionId?: number,
            supplierProductId?: number,
        ) {
            let dateOffset = new Date(deliveryStartDate).getTimezoneOffset() * 60000;
            this.deliveryStartDate = new Date(new Date(deliveryStartDate).getTime())
            
            dateOffset = new Date(deliveryEndDate).getTimezoneOffset() * 60000;
            this.deliveryEndDate = new Date(new Date(deliveryEndDate).getTime())
            
            this.priceReference = priceReference;
            this.description = description;
            this.id = id; 
            this.peak = peak;
            this.standard = standard;
            this.offPeak = offPeak;
            this.superOffPeak = superOffPeak;
            this.spGeneralConditionId = spGeneralConditionId;
            this.spParticularConditionId = spParticularConditionId;
            this.spElectricityEconomicConditionId = spElectricityEconomicConditionId;
            this.supplierProductId = supplierProductId;
        }

        [key: string]: any;
    }

    export class NaturalGasPrices {
        deliveryEndDate: Date
        deliveryStartDate: Date
        priceReference: string
        description: string
        id: string
        date: Date
        value: number

        spGeneralConditionId?: number
        spParticularConditionId?: number
        spNaturalGasEconomicConditionId?: number
        supplierProductId?: number

        basePrice: number = 0
        coverPercentage: number = 0

        constructor(
            deliveryEndDate: Date,
            deliveryStartDate: Date,
            priceReference: string,
            description: string,
            id: string,
            date: string | Date,
            value: number = 0,
            spGeneralConditionId?: number,
            spParticularConditionId?: number,
            spNaturalGasEconomicConditionId?: number,
            supplierProductId?: number
        ) {
            this.deliveryEndDate = deliveryEndDate;
            this.deliveryStartDate = deliveryStartDate;
            this.priceReference = priceReference;
            this.description = description;
            this.id = id;
            this.date = new Date(date);
            this.value = value;

            this.spGeneralConditionId = spGeneralConditionId;
            this.spParticularConditionId = spParticularConditionId;
            this.spNaturalGasEconomicConditionId = spNaturalGasEconomicConditionId;
            this.supplierProductId = supplierProductId;
        }

        [key: string]: any;
    }
}
